/*
 * UN/SET home sections: smooth scroll (Lenis), reveals on arrival, scenes tied to scrolling,
 * and the object wall in 3D. Every unset-* section loads this file; it runs once per page and
 * picks up sections as they appear, including when the theme editor re-renders one.
 */
(function () {
  'use strict';
  if (window.UnsetHome) return;

  var cfg = window.UnsetHomeConfig || {};
  var doc = document, docEl = doc.documentElement;
  var designMode = !!(window.Shopify && window.Shopify.designMode);

  function qa(el, sel) { return Array.prototype.slice.call(el.querySelectorAll(sel)); }
  function clamp01(v) { return v < 0 ? 0 : v > 1 ? 1 : v; }
  function ease(v) { return v < 0.5 ? 4 * v * v * v : 1 - Math.pow(-2 * v + 2, 3) / 2; }
  function smooth(a, b, v) { return ease(clamp01((v - a) / (b - a))); }
  function getY() { return window.pageYOffset || docEl.scrollTop || 0; }
  function wide() { return window.innerWidth >= 900; }
  function topOf(el) { return el.getBoundingClientRect().top + getY(); }
  function esc(t) { return t.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;'); }
  // style writes only when the value changes
  function setter() {
    var c = {};
    return function (el, prop, val, key) { if (el && c[key] !== val) { el.style[prop] = val; c[key] = val; } };
  }

  var scripts = {};
  function loadScript(src, cb) {
    if (!src) return;
    if (scripts[src]) { scripts[src].push(cb); return; }
    scripts[src] = [cb];
    var s = doc.createElement('script');
    s.src = src; s.async = true;
    s.onload = function () { scripts[src].forEach(function (f) { f(); }); scripts[src] = { push: function (f) { f(); } }; };
    doc.head.appendChild(s);
  }

  /* ---------- page geometry ---------- */
  var H = window.innerHeight, lastW = 0, comps = [], dirty = true, lenis = null, lastY = -1, maxY = 1;
  // window height for layout, held steady while phone toolbars slide in and out
  function setVh() {
    var w = window.innerWidth, h = window.innerHeight;
    if (w !== lastW || Math.abs(h - H) > 120 || !docEl.style.getPropertyValue('--uh-vh')) {
      H = h; lastW = w;
      docEl.style.setProperty('--uh-vh', h + 'px');
    }
    var head = 0;
    qa(doc, '.shopify-section-group-header-group').forEach(function (s) { head += s.offsetHeight; });
    docEl.style.setProperty('--uh-head', head + 'px');
  }
  function measureAll() {
    setVh();
    comps.forEach(function (c) { if (c.measure) c.measure(); });
    maxY = Math.max(1, docEl.scrollHeight - H);
    dirty = true;
  }
  var mq = 0;
  function measureSoon() { if (!mq) mq = requestAnimationFrame(function () { mq = 0; measureAll(); }); }

  /* ---------- things that arrive once: lines rise, images open in slices, rules draw in ---------- */
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
  }, { threshold: 0.15 }) : null;
  function reveal(root) { qa(root, '[data-reveal]').forEach(function (el) { if (io) io.observe(el); else el.classList.add('is-in'); }); }

  /* ---------- hero: the photograph sinks slower than the page; on the full-bleed hero the headline drifts up and fades ---------- */
  function Hero(el) {
    var set = setter(), sec = el.querySelector('.h-hero, .h-full'), full = sec && sec.classList.contains('h-full');
    var img = el.querySelector(full ? '.h-full-stage' : '.h-media img'), copy = el.querySelector('[data-hero-copy]'), g = {}, bust = null;
    if (!sec) return null;
    if (!full) setTimeout(function () { qa(el, '[data-reveal]').forEach(function (r) { r.classList.add('is-in'); }); }, 150);
    // studio time, as Halcyon shows the hour: Chandigarh time and the part of the day
    var clock = el.querySelector('[data-uh-clock]');
    if (clock) {
      var tOut = clock.querySelector('[data-t]'), pOut = clock.querySelector('[data-p]');
      var fmt = window.Intl ? new Intl.DateTimeFormat('en-GB', { timeZone: 'Asia/Kolkata', hour: '2-digit', minute: '2-digit', hour12: false }) : null;
      var tick = function () {
        if (!fmt) return;
        var s = fmt.format(new Date()), h = parseInt(s, 10);
        tOut.textContent = s;
        pOut.textContent = h < 5 || h >= 21 ? 'Night' : h < 11 ? 'Morning' : h < 17 ? 'Day' : 'Evening';
      };
      tick(); setInterval(tick, 20000);
    }
    // the bust lands: the set shakes (CSS) and dust lifts off the stone
    var bustBox = full ? el.querySelector('.h-full-stage.is-drop .h-full-bust') : null, dustCv = el.querySelector('.h-full-dust');
    if (bustBox) bustBox.addEventListener('animationend', function (e) {
      if (e.animationName !== 'uhDrop') return;
      sec.classList.add('is-impact');
      if (dustCv) dustBurst(dustCv);
      setTimeout(function () { sec.classList.remove('is-impact'); }, 900);
    });
    // the bust turns a little toward the cursor, and its shadow on the wall follows it (computers only)
    var stage = full ? el.querySelector('.h-full-stage[data-bust]') : null;
    if (stage && window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      var startBust = function () {
        loadScript(cfg.three, function () {
          if (!window.THREE) return;
          var got = {}, n = 0;
          ['cut', 'depth'].forEach(function (k) {
            loadImg(stage.getAttribute('data-' + k), function (im) { got[k] = im; if (++n === 2) bust = makeBust(stage, sec, got); });
          });
        });
      };
      if (doc.readyState === 'complete') idle(startBust); else window.addEventListener('load', function () { idle(startBust); });
    }
    return {
      el: el,
      measure: function () { g.top = topOf(sec); g.h = sec.offsetHeight || 1; if (bust) bust.layout(); },
      tick: function (now) { if (bust) bust.tick(now); },
      destroy: function () { if (bust) bust.destroy(); },
      update: function (y) {
        var p = clamp01((y - g.top) / g.h);
        if (img) set(img, 'transform', 'translate3d(0,' + (p * g.h * (full ? 0.22 : 0.16)).toFixed(1) + 'px,0) scale(' + (1 + p * (full ? 0.04 : 0.06)).toFixed(4) + ')', 'h');
        if (full && copy && wide()) {
          set(copy, 'transform', 'translate3d(0,' + (-p * g.h * 0.12).toFixed(1) + 'px,0)', 'c');
          set(copy, 'opacity', (1 - clamp01(p * 1.6)).toFixed(3), 'co');
        }
      }
    };
  }

  // dust from the impact: grains and a few soft clouds thrown out along the stone from both ends of the base, then settling
  function dustBurst(cv) {
    var ctx = cv.getContext && cv.getContext('2d');
    if (!ctx) return;
    var w = cv.clientWidth, h = cv.clientHeight, dpr = Math.min(2, window.devicePixelRatio || 1);
    if (!w || !h) return;
    cv.width = Math.round(w * dpr); cv.height = Math.round(h * dpr);
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    var by = h * 0.76, x0 = w * 0.273, x1 = w * 0.727, sc = w / 1160, ps = [], i;
    var grains = w < 700 ? 50 : 90;
    for (i = 0; i < grains + 16; i++) {
      var cloud = i >= grains, side = Math.random() < 0.5 ? -1 : 1;
      var sx = side < 0 ? x0 + Math.random() * (x1 - x0) * 0.18 : x1 - Math.random() * (x1 - x0) * 0.18;
      if (!cloud && Math.random() < 0.25) sx = x0 + Math.random() * (x1 - x0);       // some escape from under the front edge
      ps.push({
        x: sx, y: by - Math.random() * 6 * sc, cloud: cloud,
        vx: side * (cloud ? 70 + Math.random() * 90 : 60 + Math.random() * 260) * sc,
        vy: -(cloud ? 10 + Math.random() * 25 : 15 + Math.random() * 110) * sc,
        r0: (cloud ? 26 + Math.random() * 30 : 2.2 + Math.random() * 3.2) * sc,
        grow: (cloud ? 70 : 10) * sc, life: cloud ? 1.4 + Math.random() * 0.6 : 0.7 + Math.random() * 0.9,
        a0: cloud ? 0.22 + Math.random() * 0.14 : 0.22 + Math.random() * 0.22
      });
    }
    var t0 = performance.now(), last = t0;
    function frame(now) {
      var t = (now - t0) / 1000, dt = Math.min(0.05, (now - last) / 1000), alive = 0;
      last = now;
      ctx.clearRect(0, 0, w, h);
      ps.forEach(function (q) {
        if (t > q.life) return;
        alive++;
        var damp = Math.exp(-(q.cloud ? 2.2 : 3.2) * dt);
        q.vx *= damp; q.vy = q.vy * damp + (q.cloud ? 4 : 26) * sc * dt;
        q.x += q.vx * dt; q.y += q.vy * dt;
        var k = t / q.life, r = q.r0 + q.grow * k, a = q.a0 * Math.pow(1 - k, 1.6);
        var g = ctx.createRadialGradient(q.x, q.y, 0, q.x, q.y, r);
        g.addColorStop(0, 'rgba(236,226,208,' + a.toFixed(3) + ')');
        g.addColorStop(1, 'rgba(236,226,208,0)');
        ctx.fillStyle = g;
        ctx.beginPath(); ctx.ellipse(q.x, q.y, r, r * (q.cloud ? 0.55 : 1), 0, 0, Math.PI * 2); ctx.fill();
      });
      if (alive) requestAnimationFrame(frame); else ctx.clearRect(0, 0, w, h);
    }
    requestAnimationFrame(frame);
  }

  // the hero bust as a relief: same shader idea as the object wall, an orthographic camera so that at rest
  // it sits pixel for pixel on the photograph, and shading that only appears once it turns
  var BUST_VS = [
    'uniform sampler2D uDepth; uniform float uAmp; uniform float uSlope; uniform vec2 uTexel; uniform float uRy; uniform float uRx; uniform float uH;',
    'varying vec2 vUv; varying float vShade;',
    'void main() {',
    '  vUv = uv;',
    '  float d = texture2D(uDepth, uv).r;',
    '  float dx = texture2D(uDepth, uv + vec2(uTexel.x, 0.)).r - texture2D(uDepth, uv - vec2(uTexel.x, 0.)).r;',
    '  float dy = texture2D(uDepth, uv + vec2(0., uTexel.y)).r - texture2D(uDepth, uv - vec2(0., uTexel.y)).r;',
    '  vec3 p = position; p.z += (d - .5) * uAmp;',
    '  float h = clamp(p.y / uH, 0., 1.);',
    '  float a = uRy * (.12 + .88 * h * h);',
    '  float b = uRx * h;',
    '  float cy = cos(a), sy = sin(a);',
    '  p = vec3(cy * p.x + sy * p.z, p.y, -sy * p.x + cy * p.z);',
    '  float cx = cos(b), sx = sin(b);',
    '  p = vec3(p.x, cx * p.y - sx * p.z, sx * p.y + cx * p.z);',
    '  vec3 n = normalize(vec3(-dx * uSlope, -dy * uSlope, 1.));',
    '  n = vec3(cy * n.x + sy * n.z, n.y, -sy * n.x + cy * n.z);',
    '  float steep = length(vec2(dx, dy)) * uSlope;',
    '  vShade = (.9 + .12 * max(dot(n, normalize(vec3(-.35, .45, .82))), 0.)) * mix(1., .55, smoothstep(1.2, 4., steep));',
    '  gl_Position = projectionMatrix * modelViewMatrix * vec4(p, 1.);',
    '}'].join('\n');
  var BUST_FS = [
    'uniform sampler2D uMap; uniform float uShade; varying vec2 vUv; varying float vShade;',
    'void main() {',
    '  vec4 c = texture2D(uMap, vUv);',
    '  if (c.a < .02) discard;',
    '  gl_FragColor = vec4(c.rgb / max(c.a, .001) * mix(1., vShade, uShade) * c.a, c.a);',
    '}'].join('\n');
  function makeBust(stage, sec, im) {
    try {
      var T = window.THREE, holder = stage.querySelector('.h-full-bust-in'), bustBox = stage.querySelector('.h-full-bust');
      var shadow = stage.querySelector('.h-full-shadow');
      if (!holder || !bustBox) return null;
      var bw = im.cut.width, bh = im.cut.height, MX = 0.16, MY = 0.06;
      var cv = doc.createElement('canvas'); cv.setAttribute('aria-hidden', 'true'); holder.appendChild(cv);
      var r = new T.WebGLRenderer({ canvas: cv, alpha: true, antialias: false });
      r.setClearColor(0x000000, 0);
      var cam = new T.OrthographicCamera(-bw * (0.5 + MX), bw * (0.5 + MX), bh * (0.5 + MY), -bh * (0.5 + MY), -4000, 4000);
      cam.position.set(0, 0, 2000);
      var map = new T.Texture(im.cut); map.premultiplyAlpha = true; map.minFilter = T.LinearFilter; map.generateMipmaps = false; map.needsUpdate = true;
      var dm = new T.Texture(im.depth); dm.minFilter = T.LinearFilter; dm.generateMipmaps = false; dm.needsUpdate = true;
      var amp = 0.3 * bw;
      var mat = new T.ShaderMaterial({ vertexShader: BUST_VS, fragmentShader: BUST_FS, transparent: true,
        uniforms: { uMap: { value: map }, uDepth: { value: dm }, uAmp: { value: amp }, uSlope: { value: amp * im.depth.width / (2 * bw) },
                    uTexel: { value: new T.Vector2(1 / im.depth.width, 1 / im.depth.height) }, uShade: { value: 0 },
                    uRy: { value: 0 }, uRx: { value: 0 }, uH: { value: bh } } });
      mat.premultipliedAlpha = true;
      var geo = new T.PlaneGeometry(bw, bh, 170, 230);
      geo.translate(0, bh / 2, 0);                       // turn about the base, like a bust swivelling on its plinth
      var mesh = new T.Mesh(geo, mat); mesh.position.y = -bh / 2;
      var scene = new T.Scene(); scene.add(mesh);
      var o = { rx: 0, ry: 0, tx: 0, ty: 0, key: '', wd: bw, ht: bh, moved: false, start: 0, lx: 0, ly: 0, on: false, sx: -0.1, sy: 0 };
      // when the bust has landed (drop: intro + .35s + 1.15s fall + .85s settle), the turn and the wall shadow may begin
      var seen = docEl.classList.contains('uh-intro-seen');
      var landAt = stage.classList.contains('is-drop') ? (seen ? 50 : 1050) + 350 + 1150 + 850 : 0;
      var layout = function () {
        var w = cv.clientWidth, h = cv.clientHeight;
        if (!w || !h) return;
        r.setPixelRatio(Math.min(1.5, window.devicePixelRatio || 1)); r.setSize(Math.round(w), Math.round(h), false);
        o.wd = bustBox.clientWidth; o.ht = bustBox.clientHeight; o.key = '';
      };
      sec.addEventListener('pointermove', function (e) {
        if (e.pointerType !== 'mouse') return;
        var rc = bustBox.getBoundingClientRect(), cx = rc.left + rc.width / 2, cy = rc.top + rc.height * 0.38;
        o.lx = Math.max(-1, Math.min(1, (e.clientX - cx) / (window.innerWidth * 0.45)));
        o.ly = Math.max(-1, Math.min(1, (e.clientY - cy) / (window.innerHeight * 0.5)));
        o.ty = o.lx * 0.17; o.tx = o.ly * 0.07;
        o.moved = true; o.on = true;
      });
      sec.addEventListener('pointerleave', function () { o.tx = 0; o.ty = 0; o.on = false; stage.classList.remove('is-lit'); });
      sec.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') stage.classList.add('is-lit'); });
      layout();
      r.render(scene, cam);
      if (shadow) shadow.style.transform = 'translate3d(' + (-0.025 * o.wd).toFixed(1) + 'px,0,0) skewX(' + (-Math.atan(-0.1 * o.wd / o.ht) * 180 / Math.PI).toFixed(2) + 'deg)';
      setTimeout(function () { stage.classList.add('is-3d'); }, Math.max(0, landAt - performance.now()));
      return {
        layout: layout,
        tick: function (now) {
          if (now < landAt) return;
          if (!o.start) o.start = Math.max(now, landAt) + 500;
          var ty = o.ty, tx = o.tx;
          // once, after it has landed: a slow half turn so the depth reads, unless the cursor already moved it
          if (!o.moved) { var k = (now - o.start) / 2600; if (k > 0 && k < 1) ty += Math.sin(k * Math.PI * 2) * 0.12 * (1 - k); }
          o.ry += (ty - o.ry) * 0.08; o.rx += (tx - o.rx) * 0.08;
          // the cursor is the light: the shadow falls away from it; with no cursor, the photograph's own light (top right)
          var sxT = o.on ? -0.1 - o.lx * 0.32 : -0.1, syT = o.on ? 0.02 - o.ly * 0.03 : 0;
          o.sx += (sxT - o.sx) * 0.07; o.sy += (syT - o.sy) * 0.07;
          var key = o.ry.toFixed(4) + ',' + o.rx.toFixed(4) + ',' + o.sx.toFixed(4);
          if (key === o.key) return;
          o.key = key;
          mat.uniforms.uRy.value = o.ry; mat.uniforms.uRx.value = o.rx;
          mat.uniforms.uShade.value = Math.min(1, Math.abs(o.ry) * 6 + Math.abs(o.rx) * 6);
          r.render(scene, cam);
          // anchored at the base: the top of the shadow leans away from the light
          if (shadow) shadow.style.transform = 'translate3d(' + (o.sx * 0.25 * o.wd).toFixed(1) + 'px,' + (o.sy * o.wd).toFixed(1) + 'px,0) skewX(' + (-Math.atan(o.sx * o.wd / o.ht) * 180 / Math.PI).toFixed(2) + 'deg) scaleY(' + (1 + Math.abs(o.sx) * 0.12).toFixed(3) + ')';
        },
        destroy: function () { try { geo.dispose(); mat.dispose(); r.dispose(); r.forceContextLoss(); } catch (e) {} }
      };
    } catch (err) { return null; /* no WebGL: the cut-out stays, it still drops and settles */ }
  }

  /* ---------- statement: words light up as it passes through the screen ---------- */
  function Statement(el) {
    var set = setter(), st = el.querySelector('.h-state'), words = [], g = {};
    if (!st) return null;
    st.innerHTML = st.textContent.trim().split(/\s+/).map(function (w) { return '<span class="w">' + esc(w) + '</span>'; }).join(' ');
    words = qa(st, '.w');
    return {
      el: el,
      measure: function () { g.top = topOf(st); g.h = st.offsetHeight || 1; },
      update: function (y) {
        var sp = clamp01((y + H * 0.82 - g.top) / (g.h + H * 0.45)), n = words.length;
        words.forEach(function (w, i) { set(w, 'opacity', (0.14 + 0.86 * clamp01(sp * n * 1.12 - i)).toFixed(2), 'w' + i); });
      }
    };
  }

  /* ---------- feature: the photo settles, the words lift out of their lines as the reader moves on ---------- */
  function Feature(el) {
    var set = setter(), box = el.querySelector('.h-feature-img'), img = box && box.querySelector('img'), xs = qa(el, '.x'), g = {};
    return {
      el: el,
      measure: function () {
        g.top = box ? topOf(box) : 0; g.h = box ? box.offsetHeight : 1;
        g.x = xs.map(function (x) { return topOf(x.closest('.ln') || x); });
      },
      update: function (y) {
        if (img) {
          var fp = clamp01((y + H - g.top) / (H + g.h));
          set(img, 'transform', 'translate3d(0,' + ((fp - 0.5) * -16).toFixed(1) + 'px,0) scale(' + (1.05 - 0.05 * fp).toFixed(4) + ')', 'f');
        }
        xs.forEach(function (x, i) {
          var d = clamp01((y + H * 0.34 - g.x[i]) / (H * 0.2));
          set(x, 'transform', 'translate3d(0,' + (-d * 112).toFixed(1) + '%,0)', 'x' + i);
        });
      }
    };
  }

  /* ---------- process: every photo is cut into twelve planes; each step moves them the way its line reads ---------- */
  var PL = 12, KINDS = ['draw', 'cut', 'assemble', 'finish'];
  function buildLayer(i, url) {
    var el = doc.createElement('div'), h = '';
    el.className = 'pl pl-' + KINDS[i];
    for (var k = 0; k < PL; k++) h += '<div class="pl-s" style="--k:' + k + '"><img src="' + url + '" alt="" decoding="async">' + (i === 3 ? '<b></b>' : '') + '</div>';
    if (i === 1) h += '<i class="pl-cut-line"></i>';
    if (i === 3) h += '<i class="pl-light"></i>';
    el.innerHTML = h;
    return {
      el: el, kind: i, strips: qa(el, '.pl-s'), shades: qa(el, '.pl-s b'), paths: [], svg: null,
      line: el.querySelector('.pl-cut-line'), light: el.querySelector('.pl-light'), c: {}
    };
  }
  function put(o, el, prop, v, key) { if (el && o.c[key] !== v) { el.style[prop] = v; o.c[key] = v; } }
  function paint(o, t, show) {
    if (!o) return;
    var live = show && t > 0;
    if (o.c.live !== live) { o.el.classList.toggle('is-live', live); o.c.live = live; }
    if (!live || o.c.t === t) return;
    o.c.t = t;
    var k, r, e;
    if (o.kind === 0) {
      // draw: a volume becomes a field of exact profiles, then the photo fills in under the lines
      var n = o.paths.length;
      for (k = 0; k < n; k++) put(o, o.paths[k], 'strokeDashoffset', (1 - clamp01((t - k / n * 0.3) / 0.4)).toFixed(3), 'p' + k);
      for (k = 0; k < PL; k++) {
        r = ease(clamp01((t - (n ? 0.42 : 0) - k * 0.028) / 0.24));
        put(o, o.strips[k], 'opacity', r.toFixed(3), 'o' + k);
        put(o, o.strips[k], 'transform', 'translate3d(0,' + ((1 - r) * 12).toFixed(1) + 'px,0)', 't' + k);
      }
      put(o, o.svg, 'opacity', (1 - 0.72 * smooth(0.7, 1, t)).toFixed(3), 'svg');
    } else if (o.kind === 1) {
      // cut: a line runs down and leaves a precise edge behind it
      var cy = t * 1.1 - 0.05;
      for (k = 0; k < PL; k++) {
        r = clamp01((cy - k / PL) * PL);
        put(o, o.strips[k], 'clipPath', r >= 1 ? 'none' : 'inset(0 0 ' + ((1 - r) * 100).toFixed(1) + '% 0)', 'c' + k);
      }
      put(o, o.line, 'transform', 'translate3d(0,' + ((clamp01(cy) - 1) * 100).toFixed(2) + '%,0)', 'l');
      put(o, o.line, 'opacity', (smooth(-0.05, 0.02, cy) * (1 - smooth(0.95, 1.04, cy))).toFixed(3), 'lo');
    } else if (o.kind === 2) {
      // assemble: separate planes slide in and find their shared structure
      for (k = 0; k < PL; k++) {
        e = ease(clamp01((t - k * 0.02) / 0.76));
        var dir = k % 2 ? 1 : -1, off = 24 + (k * 37 % 5) * 8;
        put(o, o.strips[k], 'opacity', clamp01(e * 2.4).toFixed(3), 'o' + k);
        put(o, o.strips[k], 'transform', 'translate3d(' + (dir * (1 - e) * off).toFixed(2) + '%,' + ((k - (PL - 1) / 2) * (1 - e) * 14).toFixed(1) + 'px,0)', 't' + k);
      }
    } else {
      // finish: the planes even out, a soft light passes, the seams stay faintly as a memory
      for (k = 0; k < PL; k++) {
        r = ease(clamp01((t - (PL - 1 - k) * 0.03) / 0.14));
        put(o, o.strips[k], 'opacity', r.toFixed(3), 'o' + k);
        put(o, o.shades[k], 'opacity', ((k % 3 === 0 ? 0.42 : k % 3 === 1 ? 0.14 : 0.28) * (1 - smooth(0.3, 0.85, t))).toFixed(3), 'h' + k);
      }
      var lp = clamp01((t - 0.3) / 0.7);
      put(o, o.light, 'transform', 'translate3d(' + (-100 + 200 * ease(lp)).toFixed(1) + '%,0,0)', 'lt');
      put(o, o.light, 'opacity', Math.sin(Math.PI * lp).toFixed(3), 'lo');
    }
  }
  // draw step: the photo becomes horizontal profile lines that lift where the object is darker
  function profileSvg(url, cb) {
    var im = new Image();
    im.crossOrigin = 'anonymous';
    im.onload = function () {
      try {
        var W = 190, Hh = Math.max(10, Math.round(W * im.naturalHeight / im.naturalWidth));
        var cv = doc.createElement('canvas'); cv.width = W; cv.height = Hh;
        var cx = cv.getContext('2d'); cx.drawImage(im, 0, 0, W, Hh);
        var px = cx.getImageData(0, 0, W, Hh).data, n = W * Hh, a = new Float32Array(n), b = new Float32Array(n), i, x, y;
        for (i = 0; i < n; i++) a[i] = 1 - (px[i * 4] * 0.299 + px[i * 4 + 1] * 0.587 + px[i * 4 + 2] * 0.114) / 255;
        // soften twice so the lines follow forms, not grain
        for (var pass = 0; pass < 2; pass++) {
          for (y = 0; y < Hh; y++) for (x = 0; x < W; x++) {
            var s = 0, c = 0;
            for (var dx = -2; dx <= 2; dx++) { var xx = x + dx; if (xx >= 0 && xx < W) { s += a[y * W + xx]; c++; } }
            b[y * W + x] = s / c;
          }
          for (y = 0; y < Hh; y++) for (x = 0; x < W; x++) {
            var s2 = 0, c2 = 0;
            for (var dy = -2; dy <= 2; dy++) { var yy = y + dy; if (yy >= 0 && yy < Hh) { s2 += b[yy * W + x]; c2++; } }
            a[y * W + x] = s2 / c2;
          }
        }
        var sorted = Array.prototype.slice.call(a).sort(function (p, q) { return p - q; }), base = sorted[Math.floor(n * 0.3)];
        var S = 760 / W, VH = Math.round(Hh * S), LINES = 56, AMP = 34, d = '';
        for (var j = 0; j < LINES; j++) {
          var y0 = (j + 0.5) * VH / LINES + AMP * 0.5, row = Math.min(Hh - 1, Math.floor(y0 / S)), pts = [];
          for (x = 0; x <= W; x += 1.25) {
            var v = a[row * W + Math.min(W - 1, Math.floor(x))], lift = Math.pow(clamp01((v - base) / (1 - base)), 1.15);
            pts.push((x * S).toFixed(0) + ',' + (y0 - AMP * lift).toFixed(1));
          }
          d += '<path pathLength="1" d="M' + pts.join(' L') + '"/>';
        }
        cb('<svg class="h-pf" viewBox="0 0 760 ' + VH + '" preserveAspectRatio="xMidYMid slice" aria-hidden="true">' + d + '</svg>');
      } catch (err) { /* the photo is on another domain without CORS: the step plays without lines */ }
    };
    im.src = url + (url.indexOf('?') < 0 ? '?' : '&') + 'uh=1';
  }
  function Process(el) {
    var set = setter(), proc = el.querySelector('.h-proc'), steps = qa(el, '.h-step'), cap = el.querySelector('.h-proc-cap');
    var ticks = qa(el, '.h-proc-ticks i'), bars = qa(el, '.h-step-bar'), pm = el.querySelector('.h-proc-media .h-stage');
    var stages = qa(el, '.h-step-img'), n = Math.min(4, steps.length), g = {}, active = -1;
    var srcs = steps.map(function (s) { return s.getAttribute('data-src'); }), names = steps.map(function (s) { return s.getAttribute('data-name') || ''; });
    var desk = [], phone = [], i;
    // one pinned picture for every screen size (phones too): the per-step pictures are no longer built
    for (i = 0; i < n; i++) { var o = buildLayer(i, srcs[i]); pm.appendChild(o.el); desk.push(o); }
    if (n && desk[0]) profileSvg(srcs[0], function (svg) {
      [desk[0], phone[0]].forEach(function (o) {
        o.el.insertAdjacentHTML('beforeend', svg);
        o.svg = o.el.querySelector('.h-pf'); o.paths = qa(o.el, '.h-pf path'); o.c = {};
      });
      dirty = true;
    });
    return {
      el: el,
      measure: function () {
        g.top = topOf(proc); g.h = proc.offsetHeight;
        g.steps = steps.map(topOf); g.stages = stages.map(topOf);
      },
      update: function (y) {
        // desktop: the section holds still and each step plays across its share of the scroll
        var W = true, u = (y - (g.top - H * 0.4)) / Math.max(1, g.h - H * 0.6) * n, a = 0, k;
        if (W) a = Math.max(0, Math.min(n - 1, Math.floor(u)));
        else g.steps.forEach(function (t, j) { if (t < y + H * 0.5) a = j; });
        if (a !== active) {
          active = a;
          steps.forEach(function (s, j) { s.classList.toggle('is-on', j === a); });
          ticks.forEach(function (tk, j) { tk.classList.toggle('is-on', j <= a); });
          if (cap) cap.textContent = '0' + (a + 1) + ' / ' + names[a];
        }
        var ts = [];
        for (k = 0; k < n; k++) ts[k] = W ? clamp01((u - k) / 0.8) : 0;
        for (k = 0; k < n; k++) {
          paint(desk[k], ts[k], W && !(k < n - 1 && ts[k + 1] >= 1));
          // phones: each step's own picture plays as it rises through the screen
          paint(phone[k], W ? 0 : clamp01((y + H * 0.92 - g.stages[k]) / (H * 0.62)), !W);
          if (W) set(bars[k], 'transform', 'scaleX(' + clamp01(u - k).toFixed(3) + ')', 'b' + k);
        }
      }
    };
  }

  /* ---------- made of repetition: the layers close into one form, the word drifts behind, the facts follow ---------- */
  var RS = 18;
  function Rep(el) {
    var set = setter(), sec = el.querySelector('.h-rep'), obj = el.querySelector('.h-rep-obj'), rows = qa(el, '.h-rep-row'), facts = qa(el, '.h-rep-fact'), sl = [], g = {};
    if (obj && obj.getAttribute('data-src')) {
      var h = '';
      for (var k = 0; k < RS; k++) h += '<div class="rp-s" style="--k:' + k + '"><img src="' + obj.getAttribute('data-src') + '" alt="" decoding="async"></div>';
      obj.innerHTML = h;
      sl = qa(obj, '.rp-s');
    }
    return {
      el: el,
      measure: function () { g.top = topOf(sec); g.h = sec.offsetHeight; },
      update: function (y) {
        var W = wide(), rp = clamp01((y - (g.top - H * 0.6)) / Math.max(1, g.h - H * 0.4)), ce = ease(clamp01(rp / 0.6)), gap = H * (W ? 0.018 : 0.011);
        sl.forEach(function (s, k) {
          var off = (k - (RS - 1) / 2) * gap * (1 - ce), sx = (k % 2 ? 1 : -1) * (1 - ce) * 10;
          set(s, 'transform', 'translate3d(' + sx.toFixed(1) + 'px,' + off.toFixed(1) + 'px,0)', 's' + k);
        });
        rows.forEach(function (r, j) {
          set(r, 'transform', 'translate3d(' + ((j % 2 ? -1 : 1) * rp * 360 - 140 - (j * 211) % 520).toFixed(1) + 'px,0,0)', 'r' + j);
        });
        facts.forEach(function (f, j) {
          var fv = ease(clamp01((rp - 0.5 - j * 0.08) / 0.16));
          set(f, 'opacity', fv.toFixed(3), 'f' + j);
          set(f, 'transform', 'translate3d(0,' + ((1 - fv) * 18).toFixed(1) + 'px,0)', 'ft' + j);
        });
      }
    };
  }

  /* ---------- object wall: each cut-out is lifted into a relief from its depth map and turns under the cursor ---------- */
  var VS = [
    'uniform sampler2D uDepth; uniform float uAmp; uniform float uSlope; uniform vec2 uTexel;',
    'varying vec2 vUv; varying float vShade;',
    'void main() {',
    '  vUv = uv;',
    '  float d = texture2D(uDepth, uv).r;',
    '  float dx = texture2D(uDepth, uv + vec2(uTexel.x, 0.)).r - texture2D(uDepth, uv - vec2(uTexel.x, 0.)).r;',
    '  float dy = texture2D(uDepth, uv + vec2(0., uTexel.y)).r - texture2D(uDepth, uv - vec2(0., uTexel.y)).r;',
    '  vec3 n = normalize(normalMatrix * normalize(vec3(-dx * uSlope, -dy * uSlope, 1.)));',
    '  float steep = length(vec2(dx, dy)) * uSlope;',
    '  vShade = (.9 + .12 * max(dot(n, normalize(vec3(-.35, .45, .82))), 0.)) * mix(1., .5, smoothstep(1.2, 4., steep));',
    '  vec3 p = position; p.z += (d - .5) * uAmp;',
    '  gl_Position = projectionMatrix * modelViewMatrix * vec4(p, 1.);',
    '}'].join('\n');
  var FS = [
    'uniform sampler2D uMap; varying vec2 vUv; varying float vShade;',
    'void main() {',
    '  vec4 c = texture2D(uMap, vUv);',
    '  if (c.a < .4) discard;',
    '  float a = smoothstep(.4, .75, c.a);',
    '  gl_FragColor = vec4(c.rgb / max(c.a, .001) * vShade * a, a);',
    '}'].join('\n');
  var idle = window.requestIdleCallback || function (f) { return setTimeout(f, 60); };
  function loadImg(url, ok, fail) {
    var im = new Image();
    im.crossOrigin = 'anonymous';
    im.onload = function () { ok(im); };
    im.onerror = fail || function () {};
    im.src = url + (url.indexOf('?') < 0 ? '?' : '&') + 'uh=1';
  }
  function Wall(el) {
    var grid = el.querySelector('.h-wall-grid'), objs = [], started = false, intro = 0, dead = false;
    var items = qa(el, '.h-obj').filter(function (li) { var im = li.querySelector('img[data-depth]'); return !!im; });
    if (!items.length) return { el: el };
    function size(o) {
      var T = window.THREE, bw = o.box.clientWidth, bh = o.box.clientHeight;
      if (!bw || !bh || (bw === o.w && bh === o.h)) return;
      o.w = bw; o.h = bh;
      o.r.setPixelRatio(Math.min(2, Math.max(1.5, window.devicePixelRatio || 1))); o.r.setSize(bw, bh, false);
      o.cam.aspect = bw / bh; o.cam.updateProjectionMatrix();
      var ba = bw / bh, aw = 0.8 * ba, ah = 0.84, pw, ph;
      if (o.ia > aw / ah) { pw = aw; ph = aw / o.ia; } else { ph = ah; pw = ah * o.ia; }
      var sx = 128, sy = Math.round(128 * ph / pw);
      if (sy > 200) { sy = 200; sx = Math.round(200 * pw / ph); }
      if (o.mesh) { o.scene.remove(o.mesh); o.mesh.geometry.dispose(); }
      o.mesh = new T.Mesh(new T.PlaneGeometry(pw, ph, sx, Math.max(8, sy)), o.mat);
      var amp = 0.32 * Math.max(pw, ph), u = o.mat.uniforms;
      u.uAmp.value = amp; u.uSlope.value = amp / (2 * pw * u.uTexel.value.x);
      o.scene.add(o.mesh); o.key = '';
    }
    function bind(o, cv) {
      o.li.addEventListener('pointermove', function (e) {
        if (e.pointerType === 'mouse') {
          var rc = o.box.getBoundingClientRect();
          o.ty = ((e.clientX - rc.left) / rc.width - 0.5) * 1.12;
          o.tx = ((e.clientY - rc.top) / rc.height - 0.5) * 0.4;
          o.hover = true;
        } else if (o.drag) o.ty = Math.max(-0.6, Math.min(0.6, o.drag.ry + (e.clientX - o.drag.x) * 0.01));
      });
      o.li.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') { o.hover = false; o.tx = 0; o.ty = 0; } });
      cv.addEventListener('pointerdown', function (e) { if (e.pointerType !== 'mouse') o.drag = { x: e.clientX, ry: o.ry }; });
      var end = function () { if (o.drag) { o.drag = null; o.tx = 0; o.ty = 0; } };
      cv.addEventListener('pointerup', end); cv.addEventListener('pointercancel', end);
    }
    function make(li, i, tex, dep) {
      if (dead) return;
      try {
        var T = window.THREE, box = li.querySelector('.h-obj-img'), img = box.querySelector('img');
        var cv = doc.createElement('canvas');
        cv.setAttribute('aria-hidden', 'true');
        var r = new T.WebGLRenderer({ canvas: cv, alpha: true, antialias: false });
        r.setClearColor(0x000000, 0);
        var cam = new T.PerspectiveCamera(26, 1, 0.1, 20);
        cam.position.set(0, 0, 0.5 / Math.tan(13 * Math.PI / 180));
        var map = new T.Texture(tex); map.premultiplyAlpha = true; map.minFilter = T.LinearFilter; map.generateMipmaps = false; map.needsUpdate = true;
        var dm = new T.Texture(dep); dm.minFilter = T.LinearFilter; dm.generateMipmaps = false; dm.needsUpdate = true;
        var mat = new T.ShaderMaterial({
          vertexShader: VS, fragmentShader: FS, transparent: true,
          uniforms: { uMap: { value: map }, uDepth: { value: dm }, uAmp: { value: 0 }, uSlope: { value: 1 }, uTexel: { value: new T.Vector2(1 / dep.width, 1 / dep.height) } }
        });
        mat.premultipliedAlpha = true;
        var o = { li: li, box: box, r: r, cam: cam, scene: new T.Scene(), mat: mat, mesh: null, ia: tex.width / tex.height,
          rx: 0, ry: 0, tx: 0, ty: 0, hover: false, drag: null, w: 0, h: 0, i: i, key: '' };
        box.appendChild(cv);
        size(o); bind(o, cv); objs.push(o);
        // first draw now, while the page is idle, so the shader is compiled before anyone scrolls here
        o.r.render(o.scene, o.cam); o.key = '0.0000,0.0000';
        img.style.visibility = 'hidden';
        box.classList.add('is-3d');
      } catch (err) { /* no WebGL: the flat photo stays */ }
    }
    function start() {
      if (started) return;
      started = true;
      loadScript(cfg.three, function () {
        if (!window.THREE || dead) return;
        items.forEach(function (li, i) {
          var img = li.querySelector('img[data-depth]');
          loadImg(img.getAttribute('src'), function (tex) {
            loadImg(img.getAttribute('data-depth'), function (dep) { idle(function () { make(li, i, tex, dep); }); });
          });
        });
      });
    }
    // three.js loads once the page is idle after loading, or earlier if the wall comes near
    if (doc.readyState === 'complete') idle(start); else window.addEventListener('load', function () { idle(start); });
    if ('IntersectionObserver' in window) {
      var near = new IntersectionObserver(function (es) { if (es[0].isIntersecting) { near.disconnect(); start(); } }, { rootMargin: '120% 0px' });
      near.observe(el);
    } else start();
    return {
      el: el,
      measure: function () { objs.forEach(size); },
      tick: function (now) {
        if (!objs.length) return;
        if (!intro && grid && grid.classList.contains('is-in')) intro = now;
        objs.forEach(function (o) {
          var ty = o.ty, tx = o.tx;
          // when the wall first arrives, each piece makes one slow turn so the depth reads
          if (!o.hover && !o.drag && intro) {
            var k = (now - intro - 600 - o.i * 160) / 2000;
            if (k > 0 && k < 1) ty += Math.sin(k * Math.PI * 2) * 0.38 * (1 - k);
          }
          o.ry += (ty - o.ry) * 0.1; o.rx += (tx - o.rx) * 0.1;
          var key = o.ry.toFixed(4) + ',' + o.rx.toFixed(4);
          if (key !== o.key) { o.key = key; o.mesh.rotation.set(o.rx, o.ry, 0); o.r.render(o.scene, o.cam); }
        });
      },
      destroy: function () {
        dead = true;
        objs.forEach(function (o) { try { o.mesh.geometry.dispose(); o.mat.dispose(); o.r.dispose(); o.r.forceContextLoss(); } catch (e) {} });
        objs = [];
      }
    };
  }

  /* ---------- what we refuse to hide: the row at the middle of the screen is lit, the others wait in the half-light ---------- */
  function Rows(el) {
    var set = setter(), rows = qa(el, '.h-row'), list = el.querySelector('.h-rows'), g = {};
    if (!rows.length) return null;
    list.classList.add('is-live');
    return {
      el: el,
      measure: function () { g.c = rows.map(function (r) { return topOf(r) + r.offsetHeight / 2; }); },
      update: function (y) {
        var mid = y + H * 0.5;
        rows.forEach(function (r, i) {
          var f = 1 - smooth(0, 1, Math.abs(g.c[i] - mid) / (H * 0.3)), title = r.querySelector('h3');
          set(r, 'opacity', (0.26 + 0.74 * f).toFixed(3), 'o' + i);
          if (title) set(title, 'transform', 'translate3d(' + (f * 18).toFixed(1) + 'px,0,0)', 't' + i);
          var on = f > 0.62;
          if (r.__on !== on) { r.classList.toggle('is-focus', on); r.__on = on; }
        });
      }
    };
  }

  /* ---------- sections register themselves ---------- */
  var TYPES = { hero: Hero, statement: Statement, feature: Feature, process: Process, rep: Rep, wall: Wall, principles: Rows };
  function scan(root) {
    var found = qa(root, '.uh[data-uh]');
    if (root.matches && root.matches('.uh[data-uh]')) found.push(root);
    found.forEach(function (el) {
      if (el.__uh) return;
      el.__uh = true;
      reveal(el);
      var F = TYPES[el.getAttribute('data-uh')], c = F ? F(el) : null;
      if (c) comps.push(c);
    });
    measureAll();
  }

  /* ---------- smooth scroll; drawers and menus keep their own scrolling ---------- */
  function startLenis() {
    if (designMode || !cfg.lenis) return;
    loadScript(cfg.lenis, function () {
      if (!window.Lenis || lenis) return;
      try { lenis = new window.Lenis({ lerp: 0.085, smoothWheel: true, anchors: true }); } catch (e) { lenis = null; return; }
      var keep = function () {
        qa(doc, 'cart-drawer, .cart-drawer, .menu-drawer, .search-modal, details-modal, .mega-menu__content, .drawer__inner').forEach(function (d) { d.setAttribute('data-lenis-prevent', ''); });
      };
      keep();
      // the theme adds overflow-hidden to <body> while a drawer or modal is open
      new MutationObserver(function () {
        keep();
        if (/overflow-hidden/.test(doc.body.className)) lenis.stop(); else lenis.start();
      }).observe(doc.body, { attributes: true, attributeFilter: ['class'] });
    });
  }

  var prog = null;
  function loop(t) {
    if (lenis) lenis.raf(t);
    var y = getY();
    if (dirty || y !== lastY) {
      comps.forEach(function (c) { if (c.update) c.update(y); });
      if (prog) prog.style.transform = 'scaleX(' + clamp01(y / maxY).toFixed(4) + ')';
      lastY = y; dirty = false;
    }
    comps.forEach(function (c) { if (c.tick) c.tick(t); });
    requestAnimationFrame(loop);
  }

  function boot() {
    prog = doc.createElement('div');
    prog.className = 'uh-prog'; prog.setAttribute('aria-hidden', 'true'); prog.innerHTML = '<i></i>';
    doc.body.appendChild(prog);
    prog = prog.firstChild;
    scan(doc);
    startLenis();
    window.addEventListener('resize', measureSoon);
    window.addEventListener('load', measureAll);
    if (doc.fonts && doc.fonts.ready) doc.fonts.ready.then(measureAll);
    if (window.ResizeObserver) new ResizeObserver(measureSoon).observe(doc.body);
    // theme editor: sections are re-rendered one at a time
    doc.addEventListener('shopify:section:load', function (e) { scan(e.target); });
    doc.addEventListener('shopify:section:unload', function (e) {
      comps = comps.filter(function (c) {
        if (e.target.contains(c.el)) { if (c.destroy) c.destroy(); return false; }
        return true;
      });
      measureSoon();
    });
    requestAnimationFrame(loop);
  }

  window.UnsetHome = { refresh: measureAll, scan: scan };
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', boot); else boot();
})();
